// Discovery
export const getDiscoveryUrl = "https://api.onetwotrail.com/v1/discovery";

// Experiences
export const getExperienceUrl = `https://api.onetwotrail.com/v1/experiences/:experience_id`;

// Search
export const getSearchSearchableTermsUrl = `https://api.onetwotrail.com/v1/search/searchable_terms`;
export const createSearchUrl = "https://api.onetwotrail.com/v1/search";
